export default "__VITE_ASSET__LAGkpcgn__"